import { render, staticRenderFns } from "./FormRegistInfoStreamax.vue?vue&type=template&id=d4c72820&scoped=true&"
import script from "./FormRegistInfoStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormRegistInfoStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormRegistInfoStreamax.vue?vue&type=style&index=0&id=d4c72820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c72820",
  null
  
)

export default component.exports